<template>
  <main class="site-home">
    <section class="hero">
      <p class="eyebrow">DUE ecossistema</p>
      <h1>Uma conta única para entrar em todo o ecossistema DUE.</h1>
      <p class="lead">
        Cadastre-se uma vez, acesse seu contexto pessoal em me e seus contextos
        compartilhados em us.
      </p>
      <div class="hero-actions">
        <router-link class="btn btn-primary" to="/cadastro">
          {{ isAuthenticated ? 'Ir para me' : 'Criar conta DUE' }}
        </router-link>
        <router-link class="btn btn-secondary" to="/entrar">
          {{ isAuthenticated ? 'Trocar conta' : 'Entrar' }}
        </router-link>
      </div>
    </section>

    <section class="surface-grid">
      <article class="surface-card">
        <h2>Seu espaço pessoal</h2>
        <p>Organize sua rotina, acompanhe seus módulos e evolua no seu ritmo.</p>
        <router-link class="btn btn-ghost" to="/me">Acessar me</router-link>
      </article>
      <article class="surface-card">
        <h2>Seus espaços compartilhados</h2>
        <p>Entre em famílias, times e workspaces com módulos por contexto.</p>
        <router-link class="btn btn-ghost" to="/us">Acessar us</router-link>
      </article>
    </section>

    <section class="plans-strip">
      <div>
        <h2>Planos que crescem com seu contexto</h2>
        <p>
          Comece no plano grátis e evolua quando precisar, com benefícios
          derivados dos seus vínculos em accounts.
        </p>
      </div>
      <router-link class="btn btn-secondary" to="/planos">Ver planos</router-link>
    </section>

    <section class="trust-strip">
      <p>
        Cadastro, login, billing e acesso seguem contratos canônicos do
        ecossistema DUE.
      </p>
    </section>
  </main>
</template>

<script>
import { computed } from 'vue';
import { useStore } from 'vuex';
import { auth } from '@/config/firebase';

export default {
  name: 'HomeView',
  setup() {
    const store = useStore();
    const isAuthenticated = computed(() => {
      return Boolean((store.getters && store.getters.user) || auth.currentUser);
    });

    return { isAuthenticated };
  },
};
</script>

<style scoped>
.site-home {
  max-width: 1080px;
  margin: 120px auto 40px;
  padding: 0 20px;
  color: #13232a;
}

.hero {
  border-radius: 20px;
  padding: 32px;
  background: linear-gradient(135deg, #d9f2f5 0%, #eef7fa 60%, #ffffff 100%);
  box-shadow: 0 20px 40px rgba(15, 61, 72, 0.12);
}

.eyebrow {
  margin: 0 0 10px;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #0f7184;
}

.hero h1 {
  margin: 0;
  font-size: 40px;
  line-height: 1.1;
}

.lead {
  margin: 14px 0 0;
  max-width: 740px;
  font-size: 18px;
  line-height: 1.5;
}

.hero-actions {
  margin-top: 24px;
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

.surface-grid {
  margin-top: 22px;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
}

.surface-card {
  background: #fff;
  border: 1px solid #dce7ec;
  border-radius: 16px;
  padding: 24px;
}

.surface-card h2 {
  margin: 0;
  font-size: 24px;
}

.surface-card p {
  margin: 10px 0 18px;
  color: #35505b;
}

.plans-strip {
  margin-top: 16px;
  border-radius: 16px;
  border: 1px solid #dce7ec;
  background: #ffffff;
  padding: 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
}

.plans-strip h2 {
  margin: 0;
  font-size: 26px;
}

.plans-strip p {
  margin: 8px 0 0;
  color: #35505b;
}

.trust-strip {
  margin-top: 14px;
  border-radius: 14px;
  padding: 18px 20px;
  background: #edf5f8;
}

.trust-strip p {
  margin: 0;
  font-weight: 600;
}

.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 12px 16px;
  border-radius: 10px;
  text-decoration: none;
  font-weight: 700;
}

.btn-primary {
  background: #0a7e90;
  color: #fff;
}

.btn-secondary {
  background: #122d38;
  color: #fff;
}

.btn-ghost {
  background: #f3f8fa;
  color: #122d38;
}

@media (max-width: 900px) {
  .site-home {
    margin-top: 112px;
    padding: 0 14px 20px;
  }

  .hero {
    padding: 24px;
  }

  .hero h1 {
    font-size: 30px;
  }

  .surface-grid {
    grid-template-columns: 1fr;
  }

  .plans-strip {
    flex-direction: column;
    align-items: flex-start;
  }
}
</style>
